(function($) {
  /**
   * Initialization
   * @param {HTMLElement} $this
   */
  function init($this) {
    $this.append('<li class="more"><button type="button" class="underline" data-text="Voir moins">Voir plus</button></li>');
    $this.find('li:not(.more):nth-child(n+11)').addClass('hidden');
    $this.find('.underline').on('click', function() {
      toggleSlide($this);
    });
  }

  /**
   * Toggle slide down / up
   * @param {HTMLElement} $this
   */
  function toggleSlide($this) {
    var $button = $this.find('.underline');
    var text = $button.attr('data-text');

    $button.attr('data-text', $button.text());
    $button.text(text);

    $this.find('.hidden').each(function() {
      $(this).stop().slideToggle();
    })
  }

  $('.index').find('ul:not(.has-subtitle)').each(function() {
    if ($(this).children().length > 10) {
      init($(this));
    }
  });
})(jQuery);